import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useBoolean } from "hooks";
import { SocketsContext } from "libs/soket";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Pagination, SearchInput } from "ui";

import { DamagedItemsTable, DamagedItemModal } from "../../components";
import { useDamagedItemsList } from "../../hooks";

import styles from "./DamagedItems.module.scss";

const DamagedItems = () => {
  const { t } = useTranslation();

  const { damagedItemsSocket } = useContext(SocketsContext);

  const {
    damagedItemsList,
    isLoading,
    page,
    searchValue,
    totalItems,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    refetchDamagedItems
  } = useDamagedItemsList();

  const [showedDamagedItemId, setShowDamagedItemId] = useState<
    string | undefined
  >(undefined);
  const {
    value: isDamagedItemModalOpen,
    setTrue: onOpenModal,
    setFalse: onCloseModal
  } = useBoolean(false);

  const handleCloseModalClick = () => {
    onCloseModal();
    setShowDamagedItemId(undefined);
  };

  useEffect(() => {
    if (showedDamagedItemId != null) {
      onOpenModal();
    } else {
      onCloseModal();
    }
  }, [showedDamagedItemId, onOpenModal, onCloseModal]);

  useEffect(() => {
    if (
      damagedItemsSocket.isConnected &&
      damagedItemsList &&
      damagedItemsList.length !== 0 &&
      searchValue === "" &&
      page === 1
    ) {
      damagedItemsSocket.socket?.emit(
        "read-all-unread-counts-of-damaged-items"
      );
    }
  }, [page, damagedItemsList, searchValue, damagedItemsSocket.isConnected]);

  return (
    <div className={styles.damagedItems}>
      <div className={styles.damagedItems_headerControls}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={`${t("Search")}...`}
        />
      </div>

      <div className={styles.damagedItems_tableContainer}>
        <DamagedItemsTable
          damagedItems={damagedItemsList ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          refetchDamagedItems={refetchDamagedItems}
          onShowDamagedItem={setShowDamagedItemId}
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
        totalItems={totalItems}
      />

      <DamagedItemModal
        isOpen={isDamagedItemModalOpen}
        onClose={handleCloseModalClick}
        damagedItemId={showedDamagedItemId}
      />
    </div>
  );
};

export default DamagedItems;
